import { InjectionToken } from '@angular/core';

export interface RegHubTranslocoConfig {
  /** localStorage key used to persist the selected language for this app. */
  storageKey: string;
  prodMode: boolean;
  availableLangs?: string[];
  defaultLang?: string;
}

export const REG_HUB_TRANSLOCO_CONFIG = new InjectionToken<RegHubTranslocoConfig>('REG_HUB_TRANSLOCO_CONFIG');

export const REG_HUB_DEFAULT_LANGS = ['en', 'fr'];
export const REG_HUB_DEFAULT_LANG = 'en';
